module.exports = __webpack_public_path__ + "img/user.c362a210.svg";